export default {
  PRIMARY: "primary",
  INFO: "info",
  DANGER: "danger",
  DANGER_LASTING: "danger_lasting",
  SUCCESS: "success",
};
